/**
 * Config Class, Returns default configs
 * @author: Philipp Mazur
 */
import {ConfigRequestService} from "./services/config-request.service";

export class Configs {
    private configs: Iconfigs;
    private static instance: Configs;
    private static configAppendix: string = "config";


    constructor(callback?) {
        this.configs = <Iconfigs>{
            SERVER_URL: process.env.PUBLICATIONS_SERVER_URL
        }
        this.loadConfigValues().then(configs => {
            this.configs = configs;
            if(callback) {
                callback(configs);
            }
        });
    }

    /**
     * Singleton of the Config-Instance
     * @returns {Config}
     */
    public static getInstance(callback?) {
        if (Configs.instance) {
            return Configs.instance;
        } else {
            Configs.instance = new Configs(callback);
            return Configs.instance;
        }
    }

    /**
     * Returns the configs
     * @returns {Iconfigs}
     */
    public getConfigs(): Iconfigs {
        return this.configs;
    }

    /**
     * Default configs in case the external config.yaml file is not available
     * @returns {Iconfigs}
     */
    private async loadConfigValues() {

        console.log(process.env.PUBLICATIONS_SERVER_URL);

        let SERVER_URL: String = "";
        let CLIENT_ID: String = "";
        let AUTH_URI: String = "";
        let REALM: String = "";

        if (process.env.PUBLICATIONS_SERVER_URL)
            SERVER_URL = process.env.PUBLICATIONS_SERVER_URL;

        if (process.env.PUBLICATIONS_CLIENT_ID)
            CLIENT_ID = process.env.PUBLICATIONS_CLIENT_ID;

        if (process.env.REALM)
            REALM = process.env.PUBLICATIONS_REALM;

        if (process.env.PUBLICATIONS_AUTH_URI)
            AUTH_URI = process.env.PUBLICATIONS_AUTH_URI;

        //Call to API for other configs
        const configRequestService: ConfigRequestService = new ConfigRequestService();
        let configsFromAPI: any = await configRequestService.getConfigsFromAPI(this.configs.SERVER_URL, Configs.configAppendix);

        if (configsFromAPI.PUBLICATIONS_CLIENT_ID)
            CLIENT_ID = configsFromAPI.PUBLICATIONS_CLIENT_ID;

        if (configsFromAPI.PUBLICATIONS_REALM)
            REALM = configsFromAPI.PUBLICATIONS_REALM;

        if (configsFromAPI.PUBLICATIONS_AUTH_URI)
            AUTH_URI = configsFromAPI.PUBLICATIONS_AUTH_URI;

        let configs: Iconfigs = <Iconfigs>{
            SERVER_URL: SERVER_URL,
            CLIENT_ID: CLIENT_ID,
            AUTH_URI: AUTH_URI,
            REALM: REALM
        };
        console.dir(configs);

        return configs;
    }
}

interface Iconfigs {
    //App
    readonly SERVER_URL: string;
    readonly CLIENT_ID: string;
    readonly AUTH_URI: string;
    readonly REALM: string;
}
